import React from "react";
import ContactsTab from "./ContactsTab";

const FIELDS = [
  { name: "name", label: "Name", full: true },
  { name: "company", label: "Company" },
  { name: "profile", label: "Profile URL", full: true },
  { name: "notes", label: "Notes", type: "textarea", full: true },
];

const COLUMNS = [
  { key: "name", label: "Name", render: (v) => <span className="font-semibold">{v || "—"}</span> },
  { key: "company", label: "Company" },
  {
    key: "profile",
    label: "Profile",
    render: (v) =>
      v ? (
        <a
          href={v}
          target="_blank"
          rel="noreferrer"
          onClick={(e) => e.stopPropagation()}
          className="text-xs underline text-blue-700 font-mono-rw"
        >
          {v.length > 40 ? v.slice(0, 40) + "…" : v}
        </a>
      ) : "—",
  },
  { key: "notes", label: "Notes", render: (v) => <span className="text-xs text-neutral-500 line-clamp-1">{v || "—"}</span> },
];

const CSV_COLS = [
  { key: "name", label: "Name" },
  { key: "company", label: "Company" },
  { key: "profile", label: "Profile" },
  { key: "notes", label: "Notes" },
];

export default function LinkedInContacts() {
  return (
    <ContactsTab
      type="linkedin"
      title="LinkedIn"
      eyebrow="Contacts"
      dot="#0067B8"
      description="Professional connections sourced from LinkedIn."
      columns={COLUMNS}
      fields={FIELDS}
      excelColumns={["name", "company", "profile", "notes"]}
      csvColumns={CSV_COLS}
    />
  );
}
